import store from "@/state/store";
let userAccess = localStorage.getItem("userAccess") ? store.state.decrypt.userAccessList() : [];
let admin = store.state.decrypt.isAdmin();
export default [
  {
    path: "/",
    name: "default",
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (JSON.parse(localStorage.getItem("user")) && !JSON.parse(localStorage.getItem("user")).passwordChanged) {
          next({ name: "renewpwd" });
        } else {
          next();
        }
      },
      authRequired: true,
    },
    component: () => import("./views/dashboards/default"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (localStorage.getItem("user")) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset-password",
    name: "renewpwd",
    meta: { authRequired: true },
    component: () => import("./views/account/reset-password"),
  },
  {
    path: "/reset-forgot-password",
    name: "renewfgtpwd",
    component: () => import("./views/account/reset-forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        var theme = localStorage.getItem("theme");
        localStorage.clear();
        if(theme) {
          localStorage.setItem("theme", theme);
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) => route.push("/login"));
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom });
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  {
    path: "/500",
    name: "500",
    component: require("./views/utility/500").default,
  },
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/account-settings",
    name: "account-settings",
    meta: { authRequired: true },
    component: () => import("./views/account/account-settings"),
  },
  {
    path: "/notifications",
    name: "notifications",
    meta: { authRequired: true },
    component: () => import("./views/account/notifications"),
  },
  {
    path: "/finance/fund-cluster/sources/:id",
    name: "fund-cluster-source",
    meta: { authRequired: true },
    component: () => import("./views/finance/fund-source-id"),
  },
  {
    path: "/finance/fund-source",
    name: "fund-source",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("fund source", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/fund-source"),
  },
  {
    path: "/finance/mfo-list/:id",
    name: "mfo",
    meta: { authRequired: true },
    component: () => import("./views/finance/mfo-list"),
  },
  {
    path: "/finance/budget-line-item/:id",
    name: "budget-item",
    meta: { authRequired: true },
    component: () => import("./views/finance/budget-line-item"),
  },
  {
    path: "/administration/delivery-units",
    name: "du",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("delivery units", "administration")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/administration/du-list"),
  },
  {
    path: "/administration/resources",
    name: "all-resources",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("delivery units", "resources")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/administration/resources"),
  },
  {
    path: "/administration/external-office",
    name: "externalOffice",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("external office", "administration")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/administration/deliveryUnitExternalOffice.vue"),
  },
  {
    path: "/administration/users",
    name: "users",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("users", "administration")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/administration/users"),
  },
  {
    path: "/planning/program",
    name: "program",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("academic programs", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/program"),
  },
  {
    path: "/planning/targets",
    name: "for review",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("for pme review", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/targets"),
  },
  {
    path: "/planning/targets-rating",
    name: "rating",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("pmt rating", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/targets-rating"),
  },
  {
    path: "/planning/target-template",
    name: "target-template",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("target template", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/target-template"),
  },
  {
    path: "/planning/planning-cascaded-targets",
    name: "planning-cascaded-targets",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("pre-planning", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/preplanning"),
  },
  {
    path: "/planning/actual-targets",
    name: "actual-targets",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("targets", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/cascaded-targets"),
  },
  {
    path: "/planning/opcrs",
    name: "planning-opcrs",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("opcrs", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/opcrs"),
  },
  {
    path: "/planning/accomplishment-reports",
    name: "planning-accomplishment-reports",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("accomplishment reports", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/accomplishment-reports"),
  },
  {
    path: "/planning/budget-proposal-template",
    name: "planning-budget-proposal-template",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("budget proposal template", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/budget-proposal-template"),
  },
  {
    path: "/planning/outcome",
    name: "outcome",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("outcome", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/outcome"),
  },
  {
    path: "/planning/prexc/:id",
    name: "prexc",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("prexc", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/prexc"),
  },
  {
    path: "/planning/kpi-list/:id?",
    name: "indicator",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("kpi list", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/indicator"),
  },
  // {
  //   path: "/planning/target/:id",
  //   name: "target",
  //   meta: {
  //     authRequired: true,
  //     beforeResolve(routeTo, routeFrom, next) {
  //       if (displayMenu("target", "planning")) {
  //         next();
  //       } else {
  //         next({ name: "404" });
  //       }
  //     },
  //   },
  //   component: () => import("./views/planning/target"),
  // },
  {
    path: "/planning/api/:id",
    name: "api",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("kpi list", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/api"),
  },
  {
    path: "/office/targets",
    name: "myTarget",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("targets", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/targets"),
  },
  {
    path: "/office/api/:id?/:type?",
    name: "myAPI",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("opcr", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/api"),
  },
  {
    path: "/office/budget-item",
    name: "myBudgetItemResources",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("budget item resources", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/office-budget-item"),
  },
  {
    path: "/office/item-resources",
    name: "myItemResources",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("opcr", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/item-resources"),
  },
  {
    path: "/office/budget-proposal",
    name: "budgetProposal",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("delivery unit", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/budget-proposal"),
  },
  {
    path: "/office/request-for-disbursement",
    name: "requestForDisbursement",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("request for disbursement", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/for-charging"),
  },
  {
    path: "/office/request-for-payment",
    name: "requestForPayment",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("request for payment", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/request-for-payment"),
  },
  {
    path: "/office/pr/:id?",
    name: "pr",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("purchase request", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/pr"),
  },
  {
    path: "/department/actual",
    name: "department-actual",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("actual", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/department/actual"),
  },
  {
    path: "/department/actual-budget-item",
    name: "department-actual-budget-item",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("actual", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/department/actual-budget-item"),
  },
  {
    path: "/department/item-resources",
    name: "department-item-resources",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("actual", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/department/item-resources"),
  },
  {
    path: "/department/pr/:id?",
    name: "department-pr",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("procurement", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/department/pr"),
  },
  {
    path: "/office/item-list",
    name: "office-item-list",
    meta: {
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   if (displayMenu("purchase request", "delivery unit")) {
      //     next();
      //   } else {
      //     next({ name: "404" });
      //   }
      // },
    },
    component: () => import("./views/office/item-list"),
  },
  {
    path: "/department/item-list",
    name: "department-item-list",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("procurement", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/department/item-list"),
  },
  {
    path: "/office/incoming-deliveries",
    name: "du-deliveries",
    meta: { authRequired: true },
    component: () => import("./views/office/incoming-deliveries"),
  },
  {
    path: "/office/requisition",
    name: "requisition",
    meta: { authRequired: true },
    component: () => import("./views/office/requisition"),
  },
  {
    path: "/office/property-list",
    name: "propertyList",
    meta: { authRequired: true },
    component: () => import("./views/office/property-list"),
  },
  {
    path: "/stock/stock-request",
    name: "stock",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("stocks", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/stock/stock-request"),
  },
  {
    path: "/office/research",
    name: "office-research",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("research", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/research"),
  },
  {
    path: "/office/academic-programs",
    name: "office-academic-programs",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("academic programs", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/academic-programs"),
  },
  {
    path: "/office/department-allocation",
    name: "myDepartmentAllocation",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("department allocation", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/department-allocation"),
  },
  {
    path: "/office/services",
    name: "officeServices",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("services", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/services"),
  },
  {
    path: "/proc/bac",
    name: "procurement-bac",
    meta: {
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   if (displayMenu("bac", "procurement")) {
      //     next();
      //   } else {
      //     next({ name: "404" });
      //   }
      // },
    },
    component: () => import("./views/procurement/bac"),
  },
  {
    path: "/planning/faculties",
    name: "planning-faculties",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("faculties", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/faculties"),
  },

  {
    path: "/planning/extension-program",
    name: "planning-extension-program",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("extension program", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/extension-program"),
  },
  {
    path: "/planning/research",
    name: "research",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("research", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/research"),
  },
  {
    path: "/proc/pr-migration",
    name: "prMigration",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("purchase request migration", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/pr-migration"),
  },
  {
    path: "/proc/manage-pr",
    name: "managePR",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("manage purchase request", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/manage-pr"),
  },
  {
    path: "/proc/bids-quotations",
    name: "bids-quotations",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("bids and quotations", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/bids-quotations"),
  },
  {
    path: "/proc/bidding",
    name: "bidding",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("bidding", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/bidding"),
  },
  {
    path: "/proc/po",
    name: "po",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("purchase order", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/po"),
  },
  {
    path: "/proc/incoming-deliveries",
    name: "incoming-deliveries",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("incoming deliveries", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/incoming-deliveries"),
  },
  {
    path: "/responsibility-center/financial",
    name: "responsibility-center-financial",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("financial review", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/responsibility-center/financial"),
  },
  {
    path: "/responsibility-center/technical",
    name: "responsibility-center-technical",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("technical review", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/responsibility-center/technical"),
    // component: () => import("./views/utility/500"),
  },
  {
    path: "/office/common-files",
    name: "common-files",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("common files", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/common-files"),
  },
  {
    path: "/department/ppmp",
    name: "departmentPPMP",
    meta: { authRequired: true },
    component: () => import("./views/department/ppmp"),
  },
  {
    path: "/department/planning-targets",
    name: "department-planning-targets",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("department", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/department/planning-targets"),
  },
  {
    path: "/department/planning",
    name: "department-planning",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("department", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/department/planning"),
  },
  {
    path: "/department/planning-budget-item",
    name: "department-planning-budget-item",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("department", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/department/planning-budget-item"),
  },
  {
    path: "/inspection/incoming",
    name: "inspectionIncoming",
    // meta: { authRequired: true },
    component: () => import("./views/inspection/incoming"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("incoming delivery", "inspection")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
  },
  {
    path: "/inspection/incomingv2",
    name: "inspectionIncomingV2",
    // meta: { authRequired: true },
    component: () => import("./views/inspection/incomingv2"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("incoming delivery", "inspection")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
  },
  {
    path: "/inspection/iar",
    name: "inspectionIar",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("inspection", "inspection")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/inspection/iar"),
  },
  {
    path: "/property/releasedItems",
    name: "releasedItems",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("released items", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/releasedItems"),
  },
  {
    path: "/property/register",
    name: "propertyRegister",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("pending", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/register"),
  },
  {
    path: "/property/unassigned",
    name: "propertyUnassigned",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("un-assigned", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/unassigned"),
  },
  {
    path: "/property/transfer",
    name: "propertyTransfer",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("transfer request", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/transfer"),
  },
  {
    path: "/property/returned",
    name: "propertyReturned",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("return property request", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/returned"),
  },
  {
    path: "/property/inspection",
    name: "propertyInspection",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("inspection", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/inspection"),
  },
  {
    path: "/property/disposal",
    name: "propertyDispose",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("disposal", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/disposal"),
  },
  {
    path: "/property/expired",
    name: "propertyExpired",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("expired", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/expired"),
  },
  {
    path: "/property/posted",
    name: "propertyPosted",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("properties", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/posted"),
  },
  {
    path: "/property/properties",
    name: "propertyProperties",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("properties", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/properties"),
  },
  {
    path: "/property/inventory",
    name: "propertyInventory",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("inventory", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/inventory"),
  },
  {
    path: "/stock/stocks",
    name: "stocks",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("stocks", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/stock/stocks"),
  },
  {
    path: "/stock/transactions",
    name: "stock-request",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("stock request", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/stock/transactions"),
  },
  {
    path: "/finance/request-for-obligations",
    name: "RFPPO",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("request for obligations", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/rfp-po"),
  },
  {
    path: "/proc/item-requests",
    name: "itemRequests",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("item requests", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/item-requests"),
  },
  {
    path: "/property/settings",
    name: "propertySettings",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("settings", "supply & assets")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/property/settings"),
  },
  {
    path: "/proc/procurables",
    name: "procurables",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("list of procurables", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/procurables"),
  },
  {
    path: "/proc/annual-procurement-plan",
    name: "annual-procurement-plan",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("annual procurement plan", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/annual-procurement"),
  },
  {
    path: "/proc/pre-planning",
    name: "procurement-pre-planning",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("planning", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/preplanning"),
  },
  {
    path: "/proc/campus-pr",
    name: "procurement-pr",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("campus pr", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/campuspr"),
  },
  {
    path: "/planning/api-list",
    name: "api-list",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("api list", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/api-list"),
  },
  {
    path: "/excel-uploading",
    name: "excel-uploading",
    meta: { authRequired: true },
    component: () => import("./views/excel-uploading"),
  },
  {
    path: "/proc/item/excel-uploading",
    name: "item-excel-uploading",
    meta: { 
      authRequired: true, 
      beforeResolve(routeTo, routeFrom, next) {
        if (admin) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/item-excel-uploading"),
  },
  {
    path: "/proc/settings",
    name: "procurement-settings",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("settings", "procurement")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/procurement/settings"),
  },
  {
    path: "/planning/staffing-pattern",
    name: "staffing-pattern",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("staffing pattern", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/staffing-pattern"),
  },
  {
    path: "/planning/settings",
    name: "planning-settings",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("settings", "planning")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/planning/settings"),
  },
  {
    path: "/administration/faculties",
    name: "faculties",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("faculties", "administration")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/administration/faculties"),
  },
  {
    path: "/administration/settings",
    name: "administration-settings",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("settings", "administration")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/administration/settings"),
  },
  {
    path: "/office/planning-targets",
    name: "office-planning-targets",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("planning", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/planning-targets"),
  },
  {
    path: "/office/planning",
    name: "office-planning",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("planning", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/pre-planning"),
  },
  {
    path: "/office/planning-budget-item",
    name: "planning-budget-item",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("planning", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/planning-budget-item"),
  },
  {
    path: "/office/faculties",
    name: "office-faculties",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("faculties", "delivery unit")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/office/faculties"),
  },
  {
    path: "/dts/office-tracks",
    name: "dts-office-tracks",
    meta: { authRequired: true },
    component: () => import("./views/dts/office-tracks"),
  },
  {
    path: "/dts/office-tracks-new",
    name: "dts-office-tracks-new",
    meta: { authRequired: true },
    component: () => import("./views/dts/office-tracks(new)"),
  },
  {
    path: "/dts/incoming-tracks",
    name: "dts-incoming-tracks",
    meta: { authRequired: true },
    component: () => import("./views/dts/incoming-tracks"),
  },
  {
    path: "/dts/incoming-tracks-new",
    name: "dts-incoming-tracks-new",
    meta: { authRequired: true },
    component: () => import("./views/dts/incoming-tracks(new)"),
  },
  {
    path: "/dts/processtype-tracks",
    name: "dts-processtype-tracks",
    meta: { authRequired: true },
    component: () => import("./views/dts/processtype-tracks"),
  },
  {
    path: "/dts/dept-tracks-new",
    name: "dts-dept-tracks-new",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("department", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      }
    },
    component: () => import("./views/dts/office-tracks-dept(new)"),
  },
  {
    path: "/dts/dept-tracks",
    name: "dts-dept-tracks",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("department", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      }
    },
    component: () => import("./views/dts/office-tracks-dept"),
  },
  {
    path: "/dts/dept-incoming-tracks",
    name: "dts-dept-incoming-tracks",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("department", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/dts/incoming-tracks-dept"),
  },
  {
    path: "/dts/dept-processtype-tracks",
    name: "dts-dept-processtype-tracks",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("department", "department")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/dts/processtype-tracks-dept"),
  },
  {
    path: "/processes/all-tracks",
    name: "all tracks",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("All Tracks", "document tracking")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/dts/all-tracks"),
  },
  {
    path: "/processes/track-status",
    name: "track status",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("Track Status", "document tracking")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/dts/track-status"),
  },
  {
    path: "/processes/settings",
    name: "settings",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("settings", "document tracking")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/dts/settings"),
  },
  {
    path: "/public-posts/:type?/:id?",
    name: "public-posts",
    component: () => import("./views/public-post/index"),
  },
];
function displayMenu(menu, type) {
  let display = false;
  if (admin) {
    display = true;
  } else {
    let selectedDU = store.state.data.selectedDU;
    let user = userAccess.find((x) => x.Access.toLowerCase() === menu && x.Type.toLowerCase() === type) ? true : false;
    if(type == 'delivery unit' && menu != 'technical review') display = user && selectedDU.withDeliveryUnitAccess;
    else display = user;
  }
  return display;
}
